import { IsoCountry } from '../../common/constants';

export interface StudentDetails {
  student: {
    nationality?: IsoCountry;
    gender?: StudentDetailsGender;
    maritalStatus?: StudentDetailsMaritalStatus;
    givenName?: string;
    surname?: string;
    dateOfBirth?: Date;
  };
  contact?: {
    emailAddress?: string;
    phoneNumber?: string;
  };
  residentialAddress?: {
    numberAndStreetName?: string;
    city?: string;
    stateOrProvince?: string;
    country?: IsoCountry;
    postalCode?: string;
  };
  passport?: {
    passportNumber?: string;
    expiryDate?: Date;
  };
}

export enum StudentDetailsGender {
  Male = 'male',
  Female = 'female',
}

export enum StudentDetailsMaritalStatus {
  Single = 'single',
  Married = 'married',
}
